import { Label, Text } from '@ctct/summit-core';
import { isValidElement, type ReactNode } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

const MaxLength = ({ maxLength, formKey }: { maxLength: number; formKey: string }) => {
  const { control } = useFormContext();

  const value = useWatch({
    control,
    name: formKey,
    defaultValue: '',
  });

  return (
    <Text className="r:text-xs r:ml-auto">
      {value.length}/{maxLength}
    </Text>
  );
};

const FormFieldTopRow = ({
  label,
  isDisplayingMaxLength,
  maxLength,
  formKey,
}: {
  label?: string | ReactNode;
  isDisplayingMaxLength?: boolean;
  maxLength?: number;
  formKey: string;
}) => {
  if (!label && !isDisplayingMaxLength) return null;

  const shouldExpandLabel = isDisplayingMaxLength || isValidElement(label);
  const labelElement = label && (
    <Label className={shouldExpandLabel ? 'r:w-full' : undefined}>{label}</Label>
  );

  return (
    <div className="r:flex r:items-center r:w-full r:gap-2">
      {labelElement}
      {isDisplayingMaxLength && maxLength !== undefined && (
        <MaxLength maxLength={maxLength} formKey={formKey} />
      )}
    </div>
  );
};

export { FormFieldTopRow };
